(function () {
  var app = app || {};

  app.init = function () {
    app.detectBrowsers();
    app.factorySlider();
    app.buttonToTop();
    app.serviceVideo();
  };

  app.detectBrowsers = function () {
    var html = document.getElementsByTagName('html')[0];
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('mac') >= 0) {
      html.classList.add('is-mac');
    }
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') > -1) {
        html.classList.add('is-chrome');
      } else {
        html.classList.add('is-safari');
      }
    }
    if (ua.indexOf('msie ') > -1 || ua.indexOf('trident/') > -1) {
      html.classList.add('is-ie');
    }
    if (ua.indexOf('firefox') > -1) {
      html.classList.add('is-firefox');
    }
    if (ua.indexOf('android') > -1) {
      html.classList.add('is-android');
    }
    if (ua.match(/(iphone|ipod|ipad)/)) {
      html.classList.add('is-ios');
    }
    if (ua.indexOf('edg/') > -1) {
      html.classList.remove('is-chrome');
      html.classList.add('is-chromium');
    }
  };

  app.factorySlider = function () {
    if (!document.querySelector('.js-slider-factory')) return;
    new Swiper('.js-slider-factory', {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar'
      }
    });
  };

  app.buttonToTop = function () {
    if (!document.querySelector('.js-button-to-top')) return;
    var btns = document.querySelectorAll('.js-button-to-top');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.documentElement.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    });
  };

  app.serviceVideo = function () {
    if (!document.querySelector('.js-movie-video')) return;
    var videos = document.querySelectorAll('.js-movie-video');
    var youtubeControl = function (iframe, action) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"' + action + '","args":""}',
        '*'
      );
    }
    videos.forEach(function (video) {
      var thumbnail = video.querySelector('.js-thumbnail');
      var iframe = video.querySelector('iframe');
      iframe.addEventListener('load', function () {
        iframe.classList.add('is-loaded');
        youtubeControl(iframe, 'pauseVideo');
      });
      thumbnail.addEventListener('click', function () {
        thumbnail.classList.add('hidden');
        if (iframe.classList.contains('is-loaded')) {
          youtubeControl(iframe, 'playVideo');
        } else {
          iframe.addEventListener('load', function () {
            youtubeControl(iframe, 'playVideo');
          });
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    app.init();
  });
})();
